/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileCommitmentResponse } from '../../models/profile-commitment-response';

export interface ListCommitmentsForProfile$Params {
  id: number;
}

export function listCommitmentsForProfile(http: HttpClient, rootUrl: string, params: ListCommitmentsForProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileCommitmentResponse>>> {
  const rb = new RequestBuilder(rootUrl, listCommitmentsForProfile.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProfileCommitmentResponse>>;
    })
  );
}

listCommitmentsForProfile.PATH = '/rest/profile/{id}/commitment';
